import Exception from '@/exceptions/Exception'

export default class DomainAlreadyExistsException extends Exception {
	constructor (domain) {
		const message = `The domain "${domain}" is already used by another accounting firm`
		super(message, 'DomainAlreadyExistsException')
	}
}
